import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import {
  CitoApplicationModule,
  DomainFilter,
  DomainFilterSpelling,
  GradeLevelFilter,
  TagFilter,
} from "../shared/model/model";
import { LocalstorageService } from "../shared/services/localstorage-service.service";
import { UserService } from "../shared/services/user.service";
import {
  DashboardState,
  SetModuleAction,
  SetModuleChosenAction,
} from "../shared/store/dashboard.state";
import {
  LoadLearningObjectiveOrderAction,
  LoadLearningObjectiveOrderListsAction,
} from "../shared/store/learning-objective-order.state";
import {
  LoadLearningObjectiveAction,
  SetDomainFiltersAction,
  SetGradeFiltersAction,
  SetLearningrouteFiltersAction,
  SetReferencelevelFiltersAction,
  SetTagFiltersAction,
} from "../shared/store/learning-objectives.state";
import {
  LoadPlanningAction,
  SetReferenceLevelCandidateFiltersAction,
  SetYeargroupFiltersAction,
} from "../shared/store/planning.state";
import {
  LearningRouteFilter,
  ReferenceLevelFilter,
} from "./../shared/model/model";

import { NavbarComponent } from "../navbar/navbar.component";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  standalone: true,
  imports: [NavbarComponent],
})
export class DashboardComponent implements OnInit {
  appModule$: Observable<CitoApplicationModule>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private userService: UserService,
    private storageService: LocalstorageService
  ) {
    this.appModule$ = this.store.select(DashboardState.citomodule);
  }

  ngOnInit() {
    const hasSelectedModule = this.store.selectSnapshot<boolean>(
      (state: any) => state.dashboard.moduleChosen
    );
    const sessionModule = sessionStorage.getItem(
      `${this.userService.user.id}-citomodule`
    );

    if (!hasSelectedModule && sessionModule != null) {
      this.setAppModule(Number(sessionModule));
    }
  }

  goToWixPage() {
    window.open(
      "https://leerlinginbeeld.cito.nl/#application=leerling_in_beeld/subject=onderwerp/subjectVariant=productinformatie",
      "_new"
    );
  }

  setAppModule(module: CitoApplicationModule) {
    const gradeFilters = [
      {
        id: 3,
        value: GradeLevelFilter.GROEP3,
        name: "Groep 3",
        checked: true,
      },
      {
        id: 4,
        value: GradeLevelFilter.GROEP4,
        name: "Groep 4",
        checked: true,
      },
      {
        id: 5,
        value: GradeLevelFilter.GROEP5,
        name: "Groep 5",
        checked: true,
      },
      {
        id: 6,
        value: GradeLevelFilter.GROEP6,
        name: "Groep 6",
        checked: true,
      },
      {
        id: 7,
        value: GradeLevelFilter.GROEP7,
        name: "Groep 7",
        checked: true,
      },
      {
        id: 8,
        value: GradeLevelFilter.GROEP8,
        name: "Groep 8",
        checked: true,
      },
    ];
    const domainFiltersRekenen = [
      {
        id: 1,
        value: DomainFilter.GETALLEN,
        name: "Getallen",
        shortName: "GE",
        checked: true,
      },
      {
        id: 2,
        value: DomainFilter.VERHOUDINGEN,
        name: "Verhoudingen",
        shortName: "VH",
        checked: true,
      },
      {
        id: 3,
        value: DomainFilter.METEN_MEETKUNDE,
        name: "Meten & Meetkunde",
        shortName: "MM",
        checked: true,
      },
      {
        id: 4,
        value: DomainFilter.VERBANDEN,
        name: "Verbanden",
        shortName: "VB",
        checked: true,
      },
    ];
    const domainFiltersSpelling = [
      {
        id: 4,
        value: DomainFilterSpelling.KLANKWOORDEN,
        name: "Klankwoorden",
        shortName: "KW",
        checked: true,
      },
      {
        id: 3,
        value: DomainFilterSpelling.REGELWOORDEN,
        name: "Regelwoorden",
        shortName: "RW",
        checked: true,
      },
      {
        id: 1,
        value: DomainFilterSpelling.WEETWOORDEN,
        name: "Weetwoorden",
        shortName: "WTW",
        checked: true,
      },
      {
        id: 2,
        value: DomainFilterSpelling.WERKWOORDEN,
        name: "Werkwoorden",
        shortName: "WW",
        checked: true,
      },
    ];
    const tagFilters = [
      {
        id: 1,
        value: TagFilter.M3,
        name: "M3",
        checked: true,
      },
      {
        id: 2,
        value: TagFilter.E3,
        name: "E3",
        checked: true,
      },
      {
        id: 3,
        value: TagFilter.M4,
        name: "M4",
        checked: true,
      },
      {
        id: 4,
        value: TagFilter.E4,
        name: "E4",
        checked: true,
      },
      {
        id: 5,
        value: TagFilter.M5,
        name: "M5",
        checked: true,
      },
      {
        id: 6,
        value: TagFilter.E5,
        name: "E5",
        checked: true,
      },
      {
        id: 7,
        value: TagFilter.M6,
        name: "M6",
        checked: true,
      },
      {
        id: 8,
        value: TagFilter.E6,
        name: "E6",
        checked: true,
      },
      {
        id: 9,
        value: TagFilter.M7,
        name: "M7",
        checked: true,
      },
      {
        id: 10,
        value: TagFilter.E7,
        name: "E7",
        checked: true,
      },
      {
        id: 11,
        value: TagFilter.B8,
        name: "B8",
        checked: true,
      },
      {
        id: 12,
        value: TagFilter.M8,
        name: "M8",
        checked: true,
      },
    ];
    const referenceLevelFiltersRekenen = [
      {
        id: 1,
        value: ReferenceLevelFilter._1S,
        name: "1S",
        checked: true,
      },
      {
        id: 2,
        value: ReferenceLevelFilter._1F,
        name: "1F",
        checked: false,
      },
    ];
    const referenceLevelFiltersSpelling = [
      {
        id: 2,
        value: ReferenceLevelFilter._1F,
        name: "1F",
        checked: true,
      },
      {
        id: 3,
        value: ReferenceLevelFilter._2F,
        name: "2F",
        checked: false,
      },
      {
        id: 4,
        value: ReferenceLevelFilter._3F,
        name: "3F",
        checked: false,
      },
    ];
    const learningRoutes = [
      {
        id: 5,
        value: LearningRouteFilter.L1,
        name: "L1",
        checked: false,
      },
      {
        id: 6,
        value: LearningRouteFilter.L2,
        name: "L2",
        checked: false,
      },
      {
        id: 7,
        value: LearningRouteFilter.L3,
        name: "L3",
        checked: false,
      },
    ];
    const yeargroupFiltersCandidate = [
      {
        id: 3,
        value: GradeLevelFilter.GROEP3,
        name: "Groep 3",
        checked: true,
      },
      {
        id: 4,
        value: GradeLevelFilter.GROEP4,
        name: "Groep 4",
        checked: true,
      },
      {
        id: 5,
        value: GradeLevelFilter.GROEP5,
        name: "Groep 5",
        checked: true,
      },
      {
        id: 6,
        value: GradeLevelFilter.GROEP6,
        name: "Groep 6",
        checked: true,
      },
      {
        id: 7,
        value: GradeLevelFilter.GROEP7,
        name: "Groep 7",
        checked: true,
      },
      {
        id: 8,
        value: GradeLevelFilter.GROEP8,
        name: "Groep 8",
        checked: true,
      },
      {
        id: 9,
        value: "S",
        name: "Groep S(B)O",
        checked: true,
      },
    ];
    const referenceLevelsFiltersCandidateRekenen = [
      {
        id: 1,
        value: "1S",
        name: "Op weg naar 1S",
        checked: true,
      },
      {
        id: 2,
        value: "1F",
        name: "Op weg naar 1F",
        checked: true,
      },
      {
        id: 3,
        value: "L1",
        name: "Leerroute 1",
        checked: true,
      },
      {
        id: 4,
        value: "L2",
        name: "Leerroute 2",
        checked: true,
      },
      {
        id: 5,
        value: "L3",
        name: "Leerroute 3",
        checked: true,
      },
      {
        id: 6,
        value: "Geen profiel",
        name: "Geen profiel",
        checked: true,
      },
    ];
    const referenceLevelsFiltersCandidateSpelling = [
      {
        id: 1,
        value: "1F",
        name: "Op weg naar 1F",
        checked: true,
      },
      {
        id: 2,
        value: "2F",
        name: "Op weg naar 2F",
        checked: true,
      },
      {
        id: 3,
        value: "3F",
        name: "Op weg naar 3F",
        checked: true,
      },
      {
        id: 4,
        value: "Geen profiel",
        name: "Geen profiel",
        checked: true,
      },
    ];

    const previousSessionData = this.storageService.get(
      `previousSession-${this.userService.user.id}`
    );

    let yearGroupFiltersToSet;

    if (previousSessionData?.yeargroupfilter?.length > 0) {
      yearGroupFiltersToSet = previousSessionData.yeargroupfilter;
    } else {
      yearGroupFiltersToSet = yeargroupFiltersCandidate;
    }

    let referenceLevelFiltersToSet;

    if (
      previousSessionData?.referenceLevelFilterRekenen?.length > 0 &&
      module === CitoApplicationModule.Rekenen
    ) {
      referenceLevelFiltersToSet =
        previousSessionData.referenceLevelFilterRekenen;
    } else if (
      previousSessionData?.referenceLevelFilterSpelling?.length > 0 &&
      module === CitoApplicationModule.Spelling
    ) {
      referenceLevelFiltersToSet =
        previousSessionData.referenceLevelFilterSpelling;
    } else if (module === CitoApplicationModule.Rekenen) {
      referenceLevelFiltersToSet = referenceLevelsFiltersCandidateRekenen;
    } else {
      referenceLevelFiltersToSet = referenceLevelsFiltersCandidateSpelling;
    }

    this.store.dispatch(new SetModuleChosenAction(true));
    this.store
      .dispatch(new SetModuleAction(module))
      .subscribe((m) => [
        this.store.dispatch(new LoadPlanningAction()),
        this.store.dispatch(new LoadLearningObjectiveAction()),
        this.store.dispatch(new LoadLearningObjectiveOrderListsAction()),
        this.store.dispatch(new LoadLearningObjectiveOrderAction()),
        this.store.dispatch(new SetTagFiltersAction(tagFilters)),
        this.store.dispatch(
          new SetDomainFiltersAction(
            module === CitoApplicationModule.Rekenen
              ? domainFiltersRekenen
              : domainFiltersSpelling
          )
        ),
        this.store.dispatch(
          new SetReferencelevelFiltersAction(
            module === CitoApplicationModule.Rekenen
              ? referenceLevelFiltersRekenen
              : referenceLevelFiltersSpelling
          )
        ),

        this.store.dispatch(new SetLearningrouteFiltersAction(learningRoutes)),
        this.store.dispatch(new SetGradeFiltersAction(gradeFilters)),
        this.store.dispatch(
          new SetReferenceLevelCandidateFiltersAction(
            referenceLevelFiltersToSet
          )
        ),
        this.store.dispatch(
          new SetYeargroupFiltersAction(yearGroupFiltersToSet)
        ),
      ]);

    this.router.navigate(["/plan"]);
  }

  openInfoPage = () => {
    this.setAppModule(CitoApplicationModule.Rekenen);
    this.router.navigateByUrl("/info");
  };
}
